import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitopunecab() {



  const cardData = {
    keyword: " Mumbai to Pune Cab",

"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Pune cab services, ensuring a smooth, safe, and convenient journey for business travelers, families, students, and weekend commuters. Whether you are planning a quick business trip, a weekend getaway to Lonavala en route, or a family visit, our professional drivers and well-maintained vehicles provide a stress-free travel experience. The Mumbai to Pune route covers approximately 150 to 170 km and takes around 3 to 4 hours depending on traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Pune travel.",

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort palace in Pune built by the Peshwas of the Maratha Empire. It is famous for its grand architecture, historical significance, and light and sound show that narrates Maratha history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a majestic monument known for its architectural beauty and historical importance in India’s freedom struggle. It is where Mahatma Gandhi and other leaders were once imprisoned."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a popular hill fort near Pune known for its trekking routes, scenic views, and Maratha history. It offers breathtaking views of the Sahyadri mountains."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most famous temples dedicated to Lord Ganesha. It is known for its grand celebrations during Ganesh Chaturthi and strong spiritual significance."
  },
  {
    "title": "Lonavala",
    "description": "Lonavala is a beautiful hill station located between Mumbai and Pune, famous for its waterfalls, misty hills, and scenic valleys. It is a perfect stopover for travelers on this route."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a peaceful picnic spot near Pune offering scenic water views and beautiful sunset experiences, popular among locals and tourists."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, located in the heart of Pune city. It showcases unique architecture carved from a single rock."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses a vast collection of artifacts, musical instruments, and historical items showcasing India’s cultural heritage."
  },
  {
    "title": "Osho Ashram",
    "description": "Osho Ashram in Koregaon Park is a peaceful meditation center known for its serene environment, global visitors, and spiritual wellness programs."
  },
  {
    "title": "Mulshi Lake and Dam",
    "description": "Mulshi Lake and Dam is a scenic getaway near Pune surrounded by lush green hills, making it a perfect destination for nature lovers and weekend trips."
  }
],







services: [
  {
    name: "Mumbai to Pune Cab",
    description: "Mumbai to Pune cab service offers a fast, comfortable, and reliable travel option between two of Maharashtra’s busiest cities. The expressway route ensures a smooth and scenic journey with beautiful views of hills and tunnels. Ideal for business travelers, families, and weekend trips, this service guarantees timely pickups and safe travel. Professional drivers and well-maintained vehicles enhance the experience. Customers can choose from sedan, SUV, and luxury options. It ensures a stress-free journey."
  },
  {
    name: "Mumbai to Pune Taxi",
    description: "Mumbai to Pune taxi provides convenient door-to-door transportation with flexible travel timings. This service is perfect for travelers looking for a private and comfortable ride. Vehicles are clean and driven by experienced chauffeurs. It is suitable for corporate travel, airport transfers, and personal trips. Easy booking and reliable service ensure convenience. It guarantees a smooth travel experience."
  },
  {
    name: "Mumbai to Pune Cab Service",
    description: "Mumbai to Pune cab service is designed for efficient intercity travel with a focus on safety and comfort. The route via the Mumbai-Pune Expressway makes the journey quick and enjoyable. This service is ideal for daily commuters, business trips, and family travel. Vehicles are regularly serviced for performance. Flexible pickup options across Mumbai add convenience. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Pune Taxi Service",
    description: "Mumbai to Pune taxi service offers dependable travel with professional drivers and well-maintained vehicles. This service is suitable for all types of travelers including families and corporate clients. Flexible scheduling allows easy planning. Door-to-door service enhances comfort. It ensures a safe and hassle-free ride."
  },
  {
    name: "Cab from Mumbai to Pune",
    description: "Cab from Mumbai to Pune provides a personalized travel experience with flexible stops along the route. Travelers can enjoy a comfortable and private journey. This service is ideal for families, groups, and business travelers. Professional drivers ensure safe travel. It offers a relaxed and enjoyable road trip."
  },
  {
    name: "Taxi from Mumbai to Pune",
    description: "Taxi from Mumbai to Pune offers a quick and convenient way to travel between the two cities. With experienced drivers and comfortable vehicles, this service ensures smooth highway travel. Door-to-door pickup and drop add convenience. Suitable for short trips and frequent travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Pune Cab Booking",
    description: "Mumbai to Pune cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup location, and travel time. Instant confirmation and transparent pricing ensure a hassle-free experience. It simplifies travel planning."
  },
  {
    name: "Mumbai to Pune Taxi Booking Online",
    description: "Mumbai to Pune taxi booking online provides a quick and easy way to book your journey from anywhere. Customers can select preferred vehicles and schedule within minutes. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel hours."
  },
  {
    name: "Mumbai to Pune Cab Price",
    description: "Mumbai to Pune cab price varies based on vehicle type, trip type, and travel timing. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps customers choose according to their needs. It ensures value-driven travel."
  },
  {
    name: "Mumbai to Pune Taxi Fare",
    description: "Mumbai to Pune taxi fare is designed to be affordable and competitive for all travelers. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Pune One Way Cab",
    description: "Mumbai to Pune one way cab is a cost-effective option for travelers who need a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for business trips and relocations. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Pune Round Trip Taxi",
    description: "Mumbai to Pune round trip taxi is ideal for travelers planning a return journey. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for business meetings and family trips. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Pune Innova Cab",
    description: "Mumbai to Pune Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for long-distance and group travel. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Pune Ertiga Cab",
    description: "Mumbai to Pune Ertiga cab is suitable for small groups and families looking for an affordable ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Pune Sedan Cab",
    description: "Mumbai to Pune sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for short-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a quick journey."
  },
  {
    name: "Mumbai to Pune SUV Taxi",
    description: "Mumbai to Pune SUV taxi provides extra space and comfort for group travel. SUVs offer better stability and performance on highways. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Pune Cab",
    description: "Cheap Mumbai to Pune cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Pune Taxi Service",
    description: "Best Mumbai to Pune taxi service ensures top-quality travel with professional drivers and well-maintained vehicles. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Pune Cab", "Mumbai to Pune Taxi"],
  ["Mumbai to Pune Cab Service", "Mumbai to Pune Taxi Service"],
  ["Cab from Mumbai to Pune", "Taxi from Mumbai to Pune"],
  ["Mumbai to Pune Cab Booking", "Mumbai to Pune Taxi Booking Online"],
  ["Mumbai to Pune Cab Price", "Mumbai to Pune Taxi Fare"],
  ["Mumbai to Pune One Way Cab", "Mumbai to Pune Round Trip Taxi"],
  ["Mumbai to Pune Innova Cab", "Mumbai to Pune Ertiga Cab"],
  ["Mumbai to Pune Sedan Cab", "Mumbai to Pune SUV Taxi"],
  ["Cheap Mumbai to Pune Cab", "Best Mumbai to Pune Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Fast & Comfortable Mumbai to Pune Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Pune cab service, ideal for daily travel, corporate trips, airport transfers, and weekend journeys."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on the Mumbai–Pune Expressway, ensuring safe driving, proper lane discipline, and timely arrivals."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls, driver allowance, and all charges upfront with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Pune cab service operates 24/7, allowing flexible pickup times for early morning, late night, or urgent travel needs."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable and stress-free journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return options for quick Mumbai to Pune travel."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate groups."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by frequent travelers for Mumbai to Pune cab bookings due to punctual service, professional drivers, and reliable experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Pune cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Pune for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Pune?", answer: "The distance is approximately 150 to 170 km and takes around 3 to 4 hours via the expressway." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Pune cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, airport, and office anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during peak hours and weekends." },
  { question: "Do you provide airport drop or pickup services?", answer: "Yes, we provide Mumbai airport to Pune and Pune to Mumbai airport cab services." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Deshmukh",
    feedback: "Smooth highway drive from Mumbai to Pune with Royal Route Cabs. The ride was steady, comfortable, and the driver maintained safe speed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Joshi",
    feedback: "The Mumbai to Pune trip felt effortless. Clean car, polite driver, and no unnecessary stops made the journey quick and comfortable.",
    rating: 5
  }
];
























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-pune-cab.jpg", // replace if needed
  "description": "Book Mumbai to Pune cab with Royal Route Cabs for a fast, safe, and comfortable journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip travel. 24x7 reliable taxi service with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-pune-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Pune Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Pune cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to pune cab, mumbai to pune taxi, mumbai to pune cab service, mumbai to pune taxi service, cab from mumbai to pune, taxi from mumbai to pune, mumbai to pune cab booking, mumbai to pune taxi booking online, mumbai to pune cab price, mumbai to pune taxi fare, mumbai to pune one way cab, mumbai to pune round trip taxi, mumbai to pune innova cab, mumbai to pune ertiga cab, mumbai to pune sedan cab, mumbai to pune suv taxi, cheap mumbai to pune cab, best mumbai to pune taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopunecab;